module.exports = __webpack_public_path__ + "img/366.cee650f1.jpg";